var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ft16 ftw500 cl-placeholder",staticStyle:{"cursor":"pointer","color":"rgb(71, 114, 255)","text-align":"right","width":"35%"},style:(_vm.djs == _vm.t ? _vm.colorStyle : ''),on:{"click":_vm.djsIng}},[_vm._v(" "+_vm._s(_vm.getText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }